import { Dialog } from '@material-ui/core';
import axios from 'axios';
import { useEffect, useState } from 'react';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import CloseIcon from '@material-ui/icons/Close';
import { Button, Input, Label } from 'reactstrap';

import { baseUrl, languageId } from '../../helpers/EncryptionHelper';
import useEnterKeyListener from '../../helpers/useEnterKeyListener';

const AddDialectTypeDialog = ({
  data,
  visible,
  handleClose,
  Transition,
  editDialectType,
}) => {
  const [dialect, setDialect] = useState('');

  function handleValidation() {
    let errorText;
    if (!dialect) {
      errorText = 'Please enter WordType';
    }
    if (errorText) {
      toastr.error(errorText, 'Error!');
    } else {
      handleAddEditWordType(editDialectType);
    }
  }

  function handleAddEditWordType(isEdit) {
    let endpoint = isEdit
      ? `/dialect-type/edit/${data?._id}`
      : '/dialect-type/add';
    let axiosMethod = isEdit ? axios.put : axios.post;
    axiosMethod(baseUrl + endpoint, {
      dialectName: dialect,
      language: languageId,
    })
      .then((res) => {
        toastr.success(
          `Dialect Type ${isEdit ? 'Edited' : 'Added'} Successfully`,
          'Success'
        );
        window.location.reload(false);
      })
      .catch((error) => {
        toastr.error(
          `Dialect Type ${isEdit ? 'Edit' : 'Add'} Failed`,
          'Error!'
        );
      });
  }

  useEnterKeyListener({
    querySelectorToExecuteClick: '#submitDialectType',
  });

  useEffect(() => {
    if (data) {
      setDialect(data?.dialectName);
    }
  }, [data]);
  return (
    <Dialog
      open={visible}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <div style={{ width: 400, padding: 40 }}>
        <CloseIcon
          style={{
            position: 'absolute',
            top: 20,
            right: 20,
            cursor: 'pointer',
          }}
          onClick={handleClose}
        />
        <div className='mb-3'>
          <Label className='form-label' htmlFor='formrow-firstname-input'>
            Name
          </Label>
          <Input
            type='text'
            className='form-control'
            id='addDialectTypeInput'
            value={dialect}
            disabled={data && !editDialectType}
            onChange={(e) => setDialect(e.target.value)}
            onFocus={() => (window.focusedInput = 'addDialectTypeInput')}
          />
        </div>
        {!(data && !editDialectType) && (
          <div className='mt-4'>
            <Button
              id='submitDialectType'
              color='primary'
              variant='contained'
              className='w-md'
              onClick={() => {
                handleValidation();
              }}
            >
              Submit
            </Button>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default AddDialectTypeDialog;
